import { SVGProps } from 'react';

const MoveHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18 16 4-4-4-4m4 4H2m4 4-4-4 4-4"
    />
  </svg>
);
export default MoveHorizontal;
